'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
import { useOverlayHistory } from '@/hooks/useOverlayHistory';
interface KakaobankExitConfirmModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm?: () => void;
}
export const KakaobankExitConfirmModal = t0 => {
  const $ = _c(12);
  const {
    opened,
    onClose,
    onConfirm
  } = t0;
  useOverlayHistory(opened, onClose);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="whitespace-pre-line text-center font-700 text-Gray-900 typo-body3">{"\uACE0\uD5A5\uC0AC\uB791\uAE30\uBD80\uC81C\n\uC11C\uBE44\uC2A4\uB97C \uC885\uB8CC\uD560\uAE4C\uC694?"}</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClose) {
    t2 = <Button theme="sub-fill" onClick={onClose}>아니오</Button>;
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onConfirm) {
    t3 = <Button className="border-O-400 bg-O-400 hover:border-O-500 hover:bg-O-500 active:border-O-600 active:bg-O-600" onClick={onConfirm}>예</Button>;
    $[3] = onConfirm;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex flex-col gap-32 px-16 pb-16 pt-36">{t1}<div className="grid grid-cols-[2fr_3fr] gap-8">{t2}{t3}</div></div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onClose || $[9] !== opened || $[10] !== t4) {
    t5 = <Modal opened={opened} onClose={onClose} className="rounded-xlarge p-0 mobile:w-full lg:p-0">{t4}</Modal>;
    $[8] = onClose;
    $[9] = opened;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};